module.exports = __webpack_public_path__ + "img/pålestikk_tredd_7.e4440d96.jpg";